import { SET_CONSIGNMENT_TABLE } from '@/store/mutation-types'

const state = {}

const getters = {
  columns: (state) => state.consignmentTable || [ 'carrier', 'service', 'account', 'con_sender_name', 'edi_id', 'con_est_price' ]
}

const mutations = {
  [SET_CONSIGNMENT_TABLE] (state, data) {
    //
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations
}
